export default "__VITE_ASSET__tKnYFsXR__"